export default "/assets/content_no_results-1d853157ce1b5ce6d2bbdb914e228f78f9b63482541cfa3fc91c726e7ca08151.svg";